import api from "!../../../../../../releases/42e2d864d4f25b7276e3bf72baf9a8e3d7e3fc58/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../../releases/42e2d864d4f25b7276e3bf72baf9a8e3d7e3fc58/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[1].use[1]!../../../../../../releases/42e2d864d4f25b7276e3bf72baf9a8e3d7e3fc58/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[1].use[2]!../../../../../../releases/42e2d864d4f25b7276e3bf72baf9a8e3d7e3fc58/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[1].use[3]!./admin.scss";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};